// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-02-24T18:44:19.439Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const WorkTaskListView = lazy(() => import('@/taskmanagement/WorkTaskListView').then(m => ({ default: m.WorkTaskListView })));
const WorkTaskDetailView = lazy(() => import('@/taskmanagement/WorkTaskDetailView').then(m => ({ default: m.WorkTaskDetailView })));

/**
 * TaskManagement Module Routes
 */
export const taskmanagementRoutes = [
{ path: '/taskmanagement/worktasks',
element: <Suspense><WorkTaskListView /></Suspense> },
{ path: '/taskmanagement/worktasks/:id',
element: <Suspense><WorkTaskDetailView /></Suspense> }
];
